import { render, staticRenderFns } from "./dialog-sign-in-as.vue?vue&type=template&id=6d9465fe&"
import script from "./dialog-sign-in-as.vue?vue&type=script&lang=js&"
export * from "./dialog-sign-in-as.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports